import { useEffect } from "react";

/**
 * Prevents background scrolling when `isActive` is true.
 */
export const usePreventScroll = (isActive: boolean) => {
  useEffect(() => {
    if (isActive) {
      document.body.classList.add("ReactModal__Body--open"); // Prevent scrolling
      document.body.style.overflow = "hidden";
    } else {
      document.body.classList.remove("ReactModal__Body--open"); // Restore scrolling
      document.body.style.overflow = "auto";
    }
  }, [isActive]);
};
